/**
 * @generated SignedSource<<0b6f6dc670034cc1f1e1e2ba1bd374d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionHistoryFragment$data = {
  readonly name: string;
  readonly slug: string;
  readonly viewerCanCreateDatasetVersion: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionCreateButtonFragment" | "DatasetVersionsHelmetFragment" | "ListVersionHistoryFragment">;
  readonly " $fragmentType": "DatasetVersionHistoryFragment";
};
export type DatasetVersionHistoryFragment$key = {
  readonly " $data"?: DatasetVersionHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionHistoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionHistoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListVersionHistoryFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionsHelmetFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionCreateButtonFragment"
    },
    {
      "alias": "viewerCanCreateDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
    }
  ],
  "type": "Dataset",
  "abstractKey": null
};

(node as any).hash = "7ad304c3e868f7f2aa85ac2e10dc2dbc";

export default node;
